import * as yup from 'yup'

import {
  validatePassword,
} from '~/components/ui/PasswordField/utils'

import {
  validateEmail,
} from '~/utils'
import { EXPERIMENT_VARIANTS } from '~/constants'

export const signUpFormValidationSchema = yup.object().shape({
  email: yup.string().test(value => validateEmail(value)),
  password: yup.string().test(value => validatePassword(value)),
  promoCode: yup.string(),
  recaptchaToken: yup.string(),
  recaptchaVersion: yup.string(),
})

export const getSignUpFormDefaultValues = ([searchParams]) => {
  const email = searchParams.get('email') || ''

  return {
    email,
    password: '',
    promoCode: '',
    recaptchaToken: '',
    recaptchaVersion: '',
  }
}
